export const headerConstants = {
  tableCellNamings: [
    'FAV',
    'NAME',
    'PRICE (USD)',
    '1h %',
    '24h %',
    'VOLUME 24h',
    // Renamed from 'TVL' (2026-07-25) - Hootdex is a Central Limit Order
    // Book, not an AMM, so there is no per-token TVL. This column now shows
    // real Order Book Depth (live bids+asks) instead of the old
    // amount*price notional guess - see token.table.js. Abbreviated to
    // save table width.
    'OBD',
    'DATE & TIME',
    'MARKET STATS'
  ]
};
